import { useTranslation } from 'react-i18next'

type Props = {
  title: string
  hint?: string
  actionLabel?: string
  onAction?: () => void
}

export default function AdminEmptyState({ title, hint, actionLabel, onAction }: Props) {
  const { t } = useTranslation()
  return (
    <div className="vc-admin-empty">
      <div className="vc-admin-empty__icon" aria-hidden="true">
        ◌
      </div>
      <h3>{title}</h3>
      {hint ? <p>{hint}</p> : null}
      {actionLabel && onAction ? (
        <button type="button" className="vc-admin-btn vc-admin-btn--primary" onClick={onAction}>
          {actionLabel}
        </button>
      ) : (
        <p className="vc-admin-muted">{t('admin.emptyHint')}</p>
      )}
    </div>
  )
}
